/** Loading indicators: a small spinner and skeleton placeholders (preferred for lists). */
import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';
import styles from './ui.module.css';

export function Spinner({ size = 20, label = 'Laden…' }: { size?: number; label?: string | null }) {
  return (
    <span className={styles.spinner} role={label ? 'status' : undefined} aria-label={label ?? undefined} aria-hidden={label ? undefined : true}>
      <LoaderCircle size={size} aria-hidden="true" />
    </span>
  );
}

export function Skeleton({ width, height = 14, radius, className }: { width?: number | string; height?: number | string; radius?: number; className?: string }) {
  return <span className={clsx(styles.skeleton, className)} style={{ width, height, borderRadius: radius }} aria-hidden="true" />;
}

/** Card-shaped skeleton rows for lists. */
export function SkeletonList({ rows = 5, label = 'Laden…' }: { rows?: number; label?: string }) {
  return (
    <div className={styles.skeletonList} role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className={styles.skeletonCard}>
          <Skeleton width="38%" height={12} />
          <Skeleton width="72%" height={16} />
          <Skeleton width="54%" height={12} />
        </div>
      ))}
    </div>
  );
}

/** Generic page skeleton (header + list); used as Suspense fallback. */
export function PageSkeleton() {
  return (
    <div className={styles.pageSkeleton} role="status" aria-label="Pagina laden…">
      <Skeleton width={220} height={26} />
      <Skeleton width={320} height={14} />
      <SkeletonList rows={4} />
    </div>
  );
}
